import { useCallback, useState, useMemo } from 'react';
import React from 'react';
import { ModalComponent, useTestAudio } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var useSectionNavigationModal = function useSectionNavigationModal(_ref) {
  var updateSelectedSection = _ref.updateSelectedSection,
      sectionSummaries = _ref.sectionSummaries,
      selectedSection = _ref.selectedSection,
      modalLabels = _ref.modalLabels;

  var _useTestAudio = useTestAudio(),
      currentlyPlayingId = _useTestAudio.currentlyPlayingId,
      markAsEnded = _useTestAudio.markAsEnded,
      skippedAudio = _useTestAudio.skippedAudio,
      decrementReplays = _useTestAudio.decrementReplays;

  var _useState = useState(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = useState(null),
      focusingSection = _useState2[0],
      setFocusingSection = _useState2[1];

  var _useState3 = useState(),
      focusingQuestionIndex = _useState3[0],
      setFocusingQuestionIndex = _useState3[1];

  var onChangeSectionFromSummary = useCallback(function (section, options) {
    setFocusingSection(section);
    setFocusingQuestionIndex(options === null || options === void 0 ? void 0 : options.selectedQuestionIndex);

    if (currentlyPlayingId) {
      setIsModalOpen(true);
    } else {
      updateSelectedSection(section, options);
    }
  }, [currentlyPlayingId, updateSelectedSection]);
  var onNextSection = useCallback(function () {
    var currentIndex = sectionSummaries.findIndex(function (s) {
      return s.id.toString() === selectedSection.id.toString();
    });
    var nextIndex = currentIndex + 1;

    if (nextIndex < sectionSummaries.length) {
      var nextSection = sectionSummaries[nextIndex];
      onChangeSectionFromSummary(nextSection);
    }
  }, [sectionSummaries, selectedSection, onChangeSectionFromSummary]);
  var onPreviousSection = useCallback(function () {
    var currentIndex = sectionSummaries.findIndex(function (s) {
      return s.id.toString() === selectedSection.id.toString();
    });
    var previousIndex = currentIndex - 1;

    if (previousIndex >= 0) {
      var previousSection = sectionSummaries[previousIndex];
      onChangeSectionFromSummary(previousSection);
    }
  }, [sectionSummaries, selectedSection, onChangeSectionFromSummary]);
  var onConfirmSectionChange = useCallback(function () {
    if (focusingSection) {
      updateSelectedSection(focusingSection, {
        selectedQuestionIndex: focusingQuestionIndex
      });

      if (currentlyPlayingId) {
        markAsEnded(currentlyPlayingId);
        decrementReplays(currentlyPlayingId);
      }

      setIsModalOpen(false);
      setFocusingSection(null);
      setFocusingQuestionIndex(undefined);
    }
  }, [currentlyPlayingId, markAsEnded, updateSelectedSection, focusingSection, focusingQuestionIndex, skippedAudio, decrementReplays]);
  var modalDescription = (modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.nonSectionAudioStopTemporary) || 'Please be aware that switching to a new section will stop the current audio, and you will lose the opportunity to listen to it again.';
  var onCancelSectionChange = useCallback(function () {
    setIsModalOpen(false);
    setFocusingSection(null);
    setFocusingQuestionIndex(undefined);
  }, []);
  var modalProps = useMemo(function () {
    return {
      title: (modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirmSectionSwitchTitle) || 'Confirm Section Switch',
      open: !!currentlyPlayingId && isModalOpen,
      onOk: onConfirmSectionChange,
      onCancel: onCancelSectionChange,
      confirmButtonTitle: (modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirm) || 'Confirm',
      cancelButtonTitle: (modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.cancel) || 'Cancel',
      description: modalDescription,
      confirmMessage: (modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirmSectionSwitchMessage) || 'Are you sure you want to continue?'
    };
  }, [modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirmSectionSwitchTitle, modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirm, modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.cancel, modalLabels === null || modalLabels === void 0 ? void 0 : modalLabels.confirmSectionSwitchMessage, currentlyPlayingId, isModalOpen, onConfirmSectionChange, onCancelSectionChange, modalDescription]);
  var ConfirmModalComponent = useMemo(function () {
    return function () {
      return /*#__PURE__*/_jsxs(ModalComponent, {
        title: modalProps.title,
        open: modalProps.open,
        onOk: modalProps.onOk,
        onCancel: modalProps.onCancel,
        confirmButtonTitle: modalProps.confirmButtonTitle,
        cancelButtonTitle: modalProps.cancelButtonTitle,
        children: [/*#__PURE__*/_jsx("p", {
          children: modalProps.description
        }), /*#__PURE__*/_jsx("p", {
          children: modalProps.confirmMessage
        })]
      });
    };
  }, [modalProps]);
  return {
    isModalOpen: isModalOpen,
    modalDescription: modalDescription,
    onNextSection: onNextSection,
    onPreviousSection: onPreviousSection,
    onChangeSectionFromSummary: onChangeSectionFromSummary,
    onConfirmSectionChange: onConfirmSectionChange,
    onCancelSectionChange: onCancelSectionChange,
    ConfirmModalComponent: ConfirmModalComponent
  };
};